var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
var SvgNotification = function (props) { return (_jsx("svg", __assign({ width: 25, height: 26, viewBox: "0 0 25 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "M12.5 23.156a2.09 2.09 0 0 0 2.083-2.083h-4.166a2.09 2.09 0 0 0 2.083 2.083Zm6.25-6.25v-5.208c0-3.198-1.698-5.875-4.688-6.583v-.709A1.56 1.56 0 0 0 12.5 2.844a1.56 1.56 0 0 0-1.563 1.562v.709C7.958 5.823 6.25 8.49 6.25 11.698v5.208L4.167 18.99v1.041h16.666V18.99l-2.083-2.084Zm-2.083 1.042H8.333v-6.25c0-2.583 1.573-4.688 4.167-4.688s4.167 2.105 4.167 4.688v6.25ZM7.896 4.49 6.406 3c-2.5 1.906-4.146 4.844-4.291 8.177h2.083A8.797 8.797 0 0 1 7.896 4.49Zm12.906 6.687h2.083A10.925 10.925 0 0 0 18.594 3l-1.48 1.49a8.849 8.849 0 0 1 3.688 6.687Z", fill: "#fff" }) }))); };
var Memo = memo(SvgNotification);
export default Memo;
//# sourceMappingURL=Notification.js.map